/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JoinWaitlistBody
 */
export interface JoinWaitlistBody {
    /**
     * Team name (3-30 characters)
     * @type {string}
     * @memberof JoinWaitlistBody
     */
    name: string;
    /**
     * The captain's own in-game name (2-32 characters) — snapshot to their roster entry for score verification
     * @type {string}
     * @memberof JoinWaitlistBody
     */
    playerName: string;
    /**
     * Team tag (2-6 characters, optional)
     * @type {string}
     * @memberof JoinWaitlistBody
     */
    tag?: string;
}

/**
 * Check if a given object implements the JoinWaitlistBody interface.
 */
export function instanceOfJoinWaitlistBody(value: object): value is JoinWaitlistBody {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('playerName' in value) || value['playerName'] === undefined) return false;
    return true;
}

export function JoinWaitlistBodyFromJSON(json: any): JoinWaitlistBody {
    return JoinWaitlistBodyFromJSONTyped(json, false);
}

export function JoinWaitlistBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): JoinWaitlistBody {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'playerName': json['playerName'],
        'tag': json['tag'] == null ? undefined : json['tag'],
    };
}

export function JoinWaitlistBodyToJSON(json: any): JoinWaitlistBody {
    return JoinWaitlistBodyToJSONTyped(json, false);
}

export function JoinWaitlistBodyToJSONTyped(value?: JoinWaitlistBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'playerName': value['playerName'],
        'tag': value['tag'],
    };
}

